"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const exception_1 = require("@almservices-cl/exception");
exports.default = (arr, predicate, message) => {
    const item = arr.find(predicate);
    if (item === undefined) {
        throw new exception_1.NullPointerException(message);
    }
    return item;
};
//# sourceMappingURL=arrayFind.js.map